/* istanbul ignore file */
import allytm from '@ally/allytm'

export * from './spendingBucketsTagging'

export const clickEvent = (allytmln: string, tag = 'button'): void => {
  allytm.event('clickEvent', {
    allytmln,
    tagName: tag,
    // eslint-disable-next-line no-script-url
    href: 'javascript:void(0);',
  })
}
